
define(
    'Tavano.TavanoteamGA4.TTGA4.Shopping'
    , [
        'Tavano.TavanoteamGA4.TTGA4.Utils'
        , 'AjaxRequestsKiller'

        , 'Backbone'
        , 'jQuery'
        , 'underscore'
    ]
    , function (
        TTGA4Utils
        , AjaxRequestsKiller

        , Backbone
        , jQuery
        , _
    ) {
        'use strict';

        var ga4Shopping = {
            cartCache: []
            , loadGA4Shopping: function loadGA4Shopping(container) {
                var self = this;

                this.trackPageGA4(container);

                this.trackProductSelectEventHandler(container);

                this.app = TTGA4Utils.getApplication('Shopping');

                sessionStorage.createWishlist = "false";

                var layout = container.getComponent('Layout');

                layout.addToViewEventsDefinition(
                    'ProductList.ControlNewItem.View',
                    'click [data-action="create-and-move"]',
                    function (event) {

                        if (event.target.attributes.length > 1 && event.target.attributes.type) {
                            var targetType = event.target.attributes.type.value || "";
                            var targetClass = event.target.attributes.class.value || "";

                            if (targetType == 'submit' && targetClass == 'product-list-control-new-item-button-create') {
                                console.log("CLICK...");
                                self.trackAddToWishlist(this);
                                sessionStorage.createWishlist = "true";
                            }
                        }
                    }
                );

                // layout.addToViewEventsDefinition(
                //     'ProductList.ControlItem.View',
                //     'change [data-action="product-list-item"]',
                //     function (event) {
                //         var listChecked = event.currentTarget.checked;
                //         if (listChecked) {
                //             sessionStorage.createWishlist = "false";
                //             self.trackAddToWishlistEventHandler(container);
                //         }
                //     }
                // );

                container.getLayout().on('afterAppendView', function () {
                    
                    var curView = container.getLayout().getCurrentView()
                        , miniCart = container.getLayout().getChildViewInstance('Header').getChildViewInstance('Header.MiniCart')
                        , recentlyViewedStr = TTGA4Utils.getCookieByName('recentlyViewedIds')
                        , recentlyViewedArr = JSON.parse(decodeURIComponent(recentlyViewedStr))
                        , itemsSearcher = container.getLayout().getChildViewInstance('Header').getChildViewInstance('SiteSearch').getChildViewInstance('ItemsSeacher') ? container.getLayout().getChildViewInstance('Header').getChildViewInstance('SiteSearch').getChildViewInstance('ItemsSeacher') : {}
                        , timeout = null;

                    //to ensure that previous events listeners are removed
                    //this is to avoid multiple triggers of the same event
                    //Start
                    if (Object.keys(itemsSearcher).length > 0) {
                        itemsSearcher.$searchElement.off('keyup')
                        itemsSearcher.$searchElement.on('keyup', function (event) {
                            var searchQuery = jQuery(event.currentTarget).val();

                            clearTimeout(timeout);

                            timeout = setTimeout(function () {
                                if (searchQuery.trim().length >= itemsSearcher.options.minLength) {
                                    var resultCollection = itemsSearcher.collection
                                        , sort = itemsSearcher.options.sort
                                        , limit = itemsSearcher.options.limit
                                        , ajaxKiller = AjaxRequestsKiller.AjaxRequestsKiller ? AjaxRequestsKiller.AjaxRequestsKiller : AjaxRequestsKiller;

                                    resultCollection.fetch({
                                        data: {
                                            q: String(searchQuery).trim()
                                            , sort: sort
                                            , limit: limit
                                            , offset: 0
                                        }
                                        , killerId: ajaxKiller.getKillerId()
                                    },
                                        {
                                            silent: true
                                        })
                                        .done(function (searchResult) {
                                            if (searchResult.items.length > 0) {
                                                console.log("here")
                                                TTGA4Utils.trackSearchGA4(searchQuery.trim(), 'Search Suggestion', ga4Shopping.app);
                                            }
                                        })
                                }
                            }, 500)
                        });
                    }
                    //end

                    if (curView.getChildViewInstance('Related.Items') && curView.getChildViewInstance('Related.Items').collection.length > 0) {
                        
                        self.trackProductListsEventHandler(container, 'related');
                    }

                    if (curView.getChildViewInstance('Correlated.Items')) {
                        if (curView.getChildViewInstance('Correlated.Items').collection.models.length > 0) {
                            
                            self.trackProductListsEventHandler(container, 'correlated');
                        }
                    }

                    if (curView.getChildViewInstance('RecentlyViewed.Items') && (recentlyViewedArr && recentlyViewedArr.length > 0)) {
                       
                        self.trackProductListsEventHandler(container, 'recentlyviewed');
                    }

                    if (jQuery(curView.el)[0].id == 'facet-browse') {
                        self.trackProductListsEventHandler(container, 'plp');
                    }

                    if (miniCart) {
                        self.trackCheckout(container, 'minicart');
                    }

                    if (jQuery(curView.el)[0].id == 'ProductDetails.Full.View') {
                        self.trackAddToCartEventHandler(container);
                        self.trackProductViewGA4(container);
                        self.trackAddToWishlistEventHandler(container);
                    }

                    if (jQuery(curView.el)[0].id == 'ProductDetails.QuickView.View') {
                        self.trackAddToCartEventHandler(container);
                        self.trackProductViewGA4(container);
                        self.trackAddToWishlistEventHandler(container);
                    }

                    if (jQuery(curView.el)[0].id == "Cart.Detailed.View") {
                        self.trackRemoveItemInCartEventHandler(container);
                        self.trackViewCart(container);
                        self.trackCheckout(container, 'cart');
                        self.trackUpdateQtyEventHandler(container);
                    }

                    if (container.getLayout().getCurrentView().translator) {
                        self.trackSearch(container);
                    }
                });
            }

            , trackProductSelectEventHandler: function (container) {
                var layout = container.getLayout();

                layout.mouseDown.install({
                    name: 'tavanoTeamGA4ProductClickEvent',
                    priority: 20,
                    execute: function (e) {
                        var item = jQuery(e.currentTarget).closest('[itemprop="itemListElement"]');

                        if (item.length > 0) {
                            var category = item.data('track-productlist-category');
                            if (category) {
                                var currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD'
                                var eventObj = {
                                    item_list_id: item.data('track-productlist-category')
                                    , item_list_name: item.data('track-productlist-list')
                                    , item: [{
                                        item_id: item.data('sku') + ""
                                        , item_name: item.find('[itemprop="name"]').text()
                                        , price: item.find('[itemprop="price"]').data('rate')
                                        , item_category: item.data('track-productlist-category')
                                        , currency: currencyCode

                                    }]
                                };

                                TTGA4Utils.trackProductSelectGA4(eventObj, container);
                            }
                        }

                        return e;
                    }
                })
            }
            , trackPageGA4: function (container) {
                container.getLayout().on('beforeAppendView', function () {
                    var curUrl = Backbone.history.fragment ? '/' + Backbone.history.fragment : '/';

                    var isInModal = container.getLayout().getCurrentView().inModal;

                    if (!isInModal) {
                        TTGA4Utils.trackPageViewGA4(curUrl, container);
                    }
                });
            }
            , trackProductViewGA4: function (container) {
                var itemModel = container.getLayout().getCurrentView().model.get('item')
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD'
                    , itemData = {
                        currency: currencyCode
                        , value: itemModel.get('onlinecustomerprice_detail')['onlinecustomerprice']
                        , item: [{
                            item_id: itemModel.get('itemid')
                            , item_name: itemModel.get('storedisplayname2')
                            , price: itemModel.get('onlinecustomerprice_detail')['onlinecustomerprice']
                            , currency: currencyCode
                        }]
                    };

                TTGA4Utils.trackProductViewGA4(itemData, container);
            }
            , trackAddToCartEventHandler: function (container, page) {
                var mainActionView = container.getLayout().getCurrentView().getChildViewInstance('MainActionView') || container.getLayout().getCurrentView().mainActionViewInstance
                    , cartModel = mainActionView.cart
                    , self = this;

                ga4Shopping.pdpCart = cartModel;

                //remove previous event listener to avoid multiple triggers of the same event
                //START
                cartModel.cancelableOff('after:LiveOrder.addLines', this.trackAddToCartGA4, this);
                //END

                //Start of add to cart track event
                cartModel.cancelableOn('after:LiveOrder.addLines', this.trackAddToCartGA4, this);
                //END
            }

            , trackAddToCartGA4: function (oldline, updatedline, isAddQty) {
                var cartModel = {}
                    , itemObj = {}
                    , itemData = {}
                    , variantArr = []
                    , itemOptions = []
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';

                if (ga4Shopping.app.getLayout().getCurrentView().cart && !isAddQty) {
                    //model for when user is in PLP
                    //added item in quick view

                    cartModel = ga4Shopping.app.getLayout().getCurrentView().cart;

                    var latestItemId = cartModel.get('latest_addition')
                        , cartLines = cartModel.get('lines')
                        , latestItemModel = cartLines.get(latestItemId);

                    itemOptions = latestItemModel.get('options');

                    itemObj['item_id'] = latestItemModel.get('item').get('itemid') + "" || latestItemModel.get('item').get('itemid') + "";
                    itemObj['item_name'] = latestItemModel.get('item').get('storedisplayname2') || latestItemModel.get('item').get('displayname');
                    itemObj['quantity'] = latestItemModel.get('quantity');
                    itemObj['currency'] = currencyCode;
                    itemObj['price'] = latestItemModel.get('rate');

                    itemData['currency'] = currencyCode;
                    itemData['value'] = latestItemModel.get('total') || latestItemModel.get('amount');
                    itemData['item'] = [];
                }
                else if (ga4Shopping.app.getLayout().getCurrentView().model && !isAddQty) {
                    //model for when user is in PDP
                    //item an item in PDP

                    cartModel = ga4Shopping.app.getLayout().getCurrentView().mainActionViewInstance ? ga4Shopping.app.getLayout().getCurrentView().mainActionViewInstance.cart : ga4Shopping.pdpCart;

                    var latestAddition = ga4Shopping.app.getLayout().getCurrentView().mainActionViewInstance ? cartModel.getLatestAddition() : cartModel.getLatestAddition()
                        , price = latestAddition.get('rate') ? latestAddition.get('rate') : latestAddition.get('item').get('onlinecustomerprice_detail')['onlinecustomerprice']
                        , totalValue = latestAddition.get('total') ? latestAddition.get('total') || latestAddition.get('amount') : latestAddition.get('quantity') * price;

                    itemOptions = latestAddition.get('options');

                    var itemName = "";
                    //Use parent item name for matrix items
                    if (latestAddition.get('item').get('matrix_parent')) {
                        itemName = latestAddition.get('item').get('matrix_parent')['storedisplayname2'];
                    } else {
                        itemName = latestAddition.get('item').get('storedisplayname2') || latestAddition.get('item').get('displayname') || latestAddition.get('item').get('_name');
                    }

                    itemObj['item_id'] = latestAddition.get('item').get('itemid') + "" || latestAddition.get('item').get('internalid') + "";
                    itemObj['item_name'] = itemName
                    itemObj['quantity'] = latestAddition.get('quantity');
                    itemObj['currency'] = currencyCode;
                    itemObj['price'] = price;

                    itemData['currency'] = currencyCode;
                    itemData['value'] = totalValue;
                    itemData['item'] = [];
                }
                else if (ga4Shopping.app.getLayout().getCurrentView().model && isAddQty) {
                    //model if user added a new qty from cart
                    cartModel = ga4Shopping.app.getLayout().getCurrentView().model;

                    var updatedLine = cartModel.getLatestAddition();

                    itemOptions = updatedLine.get('options');

                    if (updatedLine.get('item')) {
                        itemObj['item_id'] = updatedLine.get('item').get('itemid') + "" || updatedLine.get('item').get('internalid') + "";
                        itemObj['item_name'] = updatedLine.get('item').get('storedisplayname2') || updatedLine.get('item').get('displayname');
                        itemObj['quantity'] = updatedLine.get('quantity');
                        itemObj['currency'] = currencyCode;
                        itemObj['price'] = updatedLine.get('item').get('onlinecustomerprice_detail').onlinecustomerprice

                        itemData['currency'] = currencyCode;
                        itemData['value'] = updatedLine.get('total') || updatedLine.get('amount');
                        itemData['item'] = [];
                    }
                }

                //checks if user selected a specific item option when they added the item to the cart
                _.each(itemOptions.models, function (option) {
                    if (option.get('value')) {
                        variantArr.push(option.get('value').label);
                    }
                });

                if (variantArr.length > 0) {
                    itemObj['item_variant'] = variantArr.join(',');
                }

                if (Object.keys(itemData).length > 0) {
                    itemData.item.push(itemObj);

                    TTGA4Utils.trackAddToCartGA4(itemData, ga4Shopping.app)
                }
            }

            , trackUpdateQtyEventHandler: function (container) {
                var cartDetailedView = container.getLayout().getCurrentView()
                    , cartDetailedModel = cartDetailedView.model;

                cartDetailedModel.cancelableOff('after:LiveOrder.updateLine', this.trackUpdateQty, this);
                cartDetailedModel.cancelableOn('after:LiveOrder.updateLine', this.trackUpdateQty, this);
            }

            , trackUpdateQty: function (oldLine) {
                var cartDetailedView = ga4Shopping.app.getLayout().getCurrentView()
                    , cartDetailModel = cartDetailedView ? cartDetailedView.model : {}
                    , cartDetailLines = cartDetailModel ? cartDetailModel.get('lines') : {}
                    , cartLinesModel = cartDetailLines ? cartDetailLines.models : {}
                    , oldLineId = oldLine.internalid
                    , cartCache = ga4Shopping.cartCache;

                //update cartCache since qty has changed
                ga4Shopping.cartCache = ga4Shopping.buildCartCache(cartLinesModel);

                _.each(cartCache, function (line) {
                    if (line.internalid == oldLineId) {
                        var cacheQty = line.itemData.item[0].quantity
                            , updatedLine = cartDetailModel ? cartDetailModel.getLatestAddition() : {}
                            , updatedLineQty = updatedLine.get('quantity');

                        if (cacheQty > updatedLineQty) {
                            ga4Shopping.trackRemoveItemInCart(updatedLine);
                        }
                        else {
                            ga4Shopping.trackAddToCartGA4(null, null, true);
                        }
                    }
                });
            }

            , trackViewCart: function (container) {
                var cartDetailedView = container.getLayout().getCurrentView()
                    , cartDetailModel = cartDetailedView.model
                    , cartData = ga4Shopping.getCartItems(cartDetailModel, "trackViewCart");

                TTGA4Utils.trackCartViewGA4(cartData, container);
            }
            , trackRemoveItemInCartEventHandler: function (container) {
                var cartDetailedView = this.app.getLayout().getCurrentView()
                    , cartDetailModel = cartDetailedView.model
                    , cartDetailLines = cartDetailModel.get('lines')
                    , cartLinesModel = cartDetailLines.models
                    , cartItemsArr = []
                    , self = this
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';

                //build array with items currently in cart
                //this will be used later to get the details of the item that was removed
                //START
                ga4Shopping.cartCache = ga4Shopping.buildCartCache(cartLinesModel);
                //END

                cartDetailModel.cancelableOff('after:LiveOrder.removeLine', this.trackRemoveItemInCart, this);
                cartDetailModel.cancelableOn('after:LiveOrder.removeLine', this.trackRemoveItemInCart, this);
            }

            , trackRemoveItemInCart: function (removedLine) {
                var cartItemsArr = ga4Shopping.cartCache || [];

                var removedItem = _.reject(cartItemsArr, function (item) {
                    var removedLineId = removedLine.internalid ? removedLine.internalid : removedLine.get('internalid');

                    return removedLineId != item.internalid;
                });

                if (removedItem) {
                    TTGA4Utils.trackRemoveItemCartGA4(removedItem[0]['itemData'], ga4Shopping.app);
                }
            }
            , trackSearch: function (container) {
                var searchQuery = container.getLayout().getCurrentView().translator.getOptionValue('keywords');

                if (searchQuery) {
                    TTGA4Utils.trackSearchGA4(searchQuery, 'Search Results Page', container);
                }
            }
            , trackAddToWishlistEventHandler: function (container) {
                var wishlistTimeout = null
                    , self = this;

                clearTimeout(wishlistTimeout);

                wishlistTimeout = setTimeout(function () {
                    var productListView = container.getLayout().getCurrentView().getChildViewInstance('AddToProductList') ? container.getLayout().getCurrentView().getChildViewInstance('AddToProductList').getChildViewInstance('ProductListControl') : {}
                        , productListViewOptions = productListView ? productListView.options : {}
                        , productListViewCollection = productListViewOptions ? productListViewOptions.collection : [];

                    if (productListViewCollection && productListViewCollection.length > 0) {
                        console.log("productListViewCollection.models", productListViewCollection.models);
                        _.each(productListViewCollection.models, function (model) {
                            var lists = model.get('items');

                            //remove any previous event listeners
                            //to avoid multiple triggers of the same event
                            lists.off('add', self.trackAddToWishlist, this);
                            lists.on('add', self.trackAddToWishlist, this);
                        })
                    }
                }, 800);
            }
            , trackAddToWishlist: function (model) {

                var productListView = ga4Shopping.app.getLayout().getCurrentView().getChildViewInstance('AddToProductList').getChildViewInstance('ProductListControl')
                    , productListViewOptions = productListView.options
                    , productListViewProduct = productListViewOptions.product
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD'
                    , itemVariant = ga4Shopping.getItemOptions(productListViewProduct);

                var itemName = "";
                //Use parent item name for matrix items
                if (productListViewProduct.get('item').get('matrix_parent')) {
                    itemName = productListViewProduct.get('item').get('matrix_parent')[storedisplayname2];
                } else {
                    itemName = productListViewProduct.get('item').get('storedisplayname2') || productListViewProduct.get('item').get('displayname') || productListViewProduct.get('item').get('_name');
                }

                var itemData = {
                    currency: currencyCode
                    , value: productListViewProduct.get('item').get('onlinecustomerprice_detail')['onlinecustomerprice']
                    , item: [{
                        item_id: productListViewProduct.get('item').get('itemid') + ""
                        , item_name: itemName
                        , currency: currencyCode
                        , price: productListViewProduct.get('item').get('onlinecustomerprice_detail')['onlinecustomerprice']
                    }]
                }

                if (itemVariant.length > 0) {
                    itemData['item'][0]['item_variant'] = itemVariant.join(',');
                }

                if (sessionStorage.createWishlist == "false" || !sessionStorage.createWishlist) {
                    TTGA4Utils.trackAddToWishlistGA4(itemData, ga4Shopping.app);
                } else {
                    sessionStorage.createWishlist = "false";
                }
            }

            , trackCheckout: function (container, cartview) {
                var cartInstance = cartview == 'minicart' ? container.getLayout().getChildViewInstance('Header').getChildViewInstance('Header.MiniCart') : container.getLayout().getCurrentView()
                    , checkoutBtn = cartInstance.$el.find('[data-touchpoint="checkout"]')
                    , cartModel = cartInstance.model
                    , promocodes = ga4Shopping.getPromotions(cartModel)
                    , eventData = ga4Shopping.getCartItems(cartModel, 'trackCheckout');

                if (promocodes.length > 0) {
                    eventData['coupon'] = promocodes.join(',');
                }

                //workaround
                //there are instances that the minicart module isn't loaded
                //that is why the checkout button is not loaded as well and we cannot add an event listener
                //which causes the trackCheckout event to break
                //TO DO -- improve workaround; make it cleaner
                if (cartview == 'minicart' && cartInstance.events) {
                    // _.extend(cartInstance, {
                    //     trackEvent: _.wrap(cartInstance['trackEvent'], function(fn)
                    //     {
                    //         fn.apply(this,arguments) + TTGA4Utils.trackBeginCheckoutGA4(eventData, container);
                    //         console.log("dataLayer begin checkout", JSON.stringify(window.dataLayer))
                    //     })
                    // })
                    if (checkoutBtn.length > 0) {
                        // _.each(checkoutBtn, function(btn)
                        // {
                        jQuery(checkoutBtn).off('click');
                        jQuery(checkoutBtn).on('click', function () {
                            TTGA4Utils.trackBeginCheckoutGA4(eventData, container);
                            console.log("dataLayer begin checkout", JSON.stringify(window.dataLayer))
                        })
                        // })
                    }
                    else {
                        var eventsObj = _.extend({}, cartInstance.events, {
                            'click [data-touchpoint="checkout"]': 'trackTTCheckout'
                        });

                        Object.defineProperty(cartInstance, 'events', {
                            get: function () {
                                return eventsObj;
                            }
                            , set: function () {
                                return eventsObj;
                            }
                            , configurable: true
                        })

                        cartInstance.trackTTCheckout = _.wrap(cartInstance['trackEvent'], function (fn) {
                            fn.apply(this, arguments) + TTGA4Utils.trackBeginCheckoutGA4(eventData, container);
                            console.log("dataLayer", JSON.stringify(window.dataLayer));
                        })
                    }

                    // cartInstance.trackTTCheckout = function(e)
                    // {
                    //     TTGA4Utils.trackBeginCheckoutGA4(eventData, container);
                    //     console.log("dataLayer", JSON.stringify(window.dataLayer));
                    // }   
                }
                else {
                    if (checkoutBtn.length > 0) {
                        // _.each(checkoutBtn, function(btn)
                        // {
                        jQuery(checkoutBtn).on('click', function () {
                            TTGA4Utils.trackBeginCheckoutGA4(eventData, container);
                            console.log("dataLayer begin checkout", JSON.stringify(window.dataLayer))
                        })
                        // })
                    }
                }

                console.log("checkoutBtn", checkoutBtn);
            }

            , trackProductListsEventHandler: function (container, source) {
                
                var listId = ''
                    , listName = ''
                    , curView = container.getLayout().getCurrentView()
                    , listItems = []
                    , self = this
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';

                if (source == 'plp') {
                    var itemModels = curView.model ? curView.model.get("items").models : [];

                    listItems = this.getListItems(itemModels)
                    listId = 'category';
                    listName = curView.model.get('category') ? curView.model.get('category').get('name') : 'All Products Page';

                    var eventData = {
                        item_list_id: listId
                        , item_list_name: listName
                        , currency: currencyCode
                        , items: listItems
                    };

                    TTGA4Utils.trackProductListGA4(eventData, container)
                }
                else {
                    this.trackOtherItemLists(container, source);
                }
            }

            , trackOtherItemLists: function (container, source) {
                var listId = ''
                    , listName = ''
                    , curView = container.getLayout().getCurrentView()
                    , listItems = []
                    , eventData = {}
                    , self = this
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';

                setTimeout(function () {
                    

                    if (source == 'correlated') {
                        
                        var correlatedModel = curView.getChildViewInstance('Correlated.Items').collection.models;

                        if (correlatedModel.length > 0) {
                            listItems = self.getListItems(correlatedModel)
                            listId = 'correlated_items';
                            listName = 'Correlated Items';

                            eventData = {
                                item_list_id: listId
                                , item_list_name: listName
                                , currency: currencyCode
                                , items: listItems
                            };
                        }
                    }

                    if (source == 'recentlyviewed') {
                        
                        var recentlyModel = curView.getChildViewInstance('RecentlyViewed.Items').collection.models;

                        listItems = self.getListItems(recentlyModel)
                        listId = 'recently_viewed_items';
                        listName = 'Recently Viewed Items';

                        eventData = {
                            item_list_id: listId
                            , item_list_name: listName
                            , currency: currencyCode
                            , items: listItems
                        };
                    }

                    if (source == 'related') {
                        
                        var relatedModel = curView.getChildViewInstance('Related.Items') ? curView.getChildViewInstance('Related.Items').collection.models : [];

                        listItems = self.getListItems(relatedModel)
                        listId = 'related_items';
                        listName = 'Related Items';

                        eventData = {
                            item_list_id: listId
                            , item_list_name: listName
                            , currency: currencyCode
                            , items: listItems
                        };
                    }
                
                    if (listId != '' && listName != '' && listItems.length > 0) {
                        TTGA4Utils.trackProductListGA4(eventData, container)
                    }

                }, 2000);
            }

            , getListItems: function (collection) {
                var itemsArr = []
                    , items = collection.models ? collection.models : collection
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';

                _.each(items, function (item) {

                    itemsArr.push({
                        item_id: item.get('itemid') + ""
                        , item_name: item.get('storedisplayname2') || item.get('displayname') || item.get('_name')
                        , price: item.get('onlinecustomerprice')
                        , currency: currencyCode
                    })
                });

                return itemsArr;
            }

            , getPromotions: function (model) {
                var promocodes = model.get('promocodes') || []
                    , codes = [];

                _.each(promocodes, function (val) {
                    codes.push(val.code);
                });

                return codes;
            }

            , getCartItems: function (model, stage) {
                var cartItemsObj = {}
                    , itemsArr = []
                    , promocodes = ga4Shopping.getPromotions(model)
                    , lines = model.get('lines')
                    , self = this
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';

                _.each(lines.models, function (line) {
                    var itemName = "";
                    //Use parent item name for matrix items
                    if (line.get('item').get('matrix_parent')) {
                        itemName = line.get('item').get('matrix_parent').storedisplayname2 || line.get('item').get('matrix_parent').get('storedisplayname2');
                    } else {
                        itemName = line.get('item').get('storedisplayname2') || line.get('item').get('displayname') || line.get('item').get('_name');
                    }

                    var itemVariant = self.getItemOptions(line)
                        , itemsObj = {
                            item_id: line.get('item').get('itemid') + ""
                            , item_name: itemName
                            , quantity: line.get('quantity')
                            , currency: currencyCode
                            , price: line.get('item').get('onlinecustomerprice_detail').onlinecustomerprice
                        };

                    if (promocodes.length > 0) {
                        itemsObj['coupon'] = promocodes.join(',');
                    }

                    if (itemVariant.length > 0) {
                        itemsObj['item_variant'] = itemVariant.join(',')
                    }

                    itemsArr.push(itemsObj);
                });

                cartItemsObj.currency = currencyCode;

                if (model.get('summary')) {
                    cartItemsObj.value = model.get('summary').total;
                }

                if (stage == 'trackCheckout') {
                    cartItemsObj.items_checkout = itemsArr;
                } else {
                    cartItemsObj.items = itemsArr;
                }

                return cartItemsObj;
            }

            , buildCartCache: function (line_model) {
                var cartItemsArr = []
                    , currencyCode = SC.ENVIRONMENT.currentCurrency && SC.ENVIRONMENT.currentCurrency.code || 'USD';

                _.each(line_model, function (line) {
                    var item = line.get('item')
                        , variantArr = ga4Shopping.getItemOptions(line)
                        , itemsObj = {
                            item_id: item.get('itemid') || item.get('internalid')
                            , item_name: item.get('storedisplayname2') || item.get('displayname')
                            , quantity: line.get('quantity')
                            , currency: currencyCode
                            , price: line.get('item').get('onlinecustomerprice_detail').onlinecustomerprice
                        };

                    if (variantArr.length > 0) {
                        itemsObj['item_variant'] = variantArr.join(',');
                    }

                    cartItemsArr.push({
                        internalid: line.get('internalid')
                        , itemData: {
                            currency: currencyCode
                            , value: line.get('amount')
                            , item: [itemsObj]
                        }
                    });
                });

                return cartItemsArr;
            }

            , getItemOptions: function (item) {
                var variantsArr = []
                    , itemOptions = item.get('options') || []
                    , itemOptionsModel = itemOptions.models || [];

                _.each(itemOptionsModel, function (option) {
                    var optionsValue = option.get('value') || {};

                    if (Object.keys(optionsValue).length > 0) {
                        variantsArr.push(optionsValue.label);
                    }
                });

                return variantsArr;
            }
        }

        return ga4Shopping;
    });
